import { render, staticRenderFns } from "./OrgAdd.vue?vue&type=template&id=1e854447&scoped=true"
import script from "./OrgAdd.vue?vue&type=script&lang=js"
export * from "./OrgAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e854447",
  null
  
)

export default component.exports